import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MapPin, Mail, Phone } from "lucide-react";
import { useInitiatives } from "@/lib/useInitiatives";

export default function Footer() {
  const { t } = useTranslation();
  const { byCategory } = useInitiatives();

  return (
    <footer data-testid="site-footer" role="contentinfo" className="mt-24 band-dark circuit-bg">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
        <div className="lg:col-span-2">
          <div className="inline-block bg-white p-3 mb-5">
            <img src="/semicon-keralam-logo.png" alt={`${t("meta.brand")} — ${t("meta.tagline")}`} className="h-14 w-auto" />
          </div>
          <p className="text-white/85 text-sm leading-relaxed max-w-md">{t("footer.about")}</p>
          <p className="mt-4 font-mono text-[10px] uppercase tracking-widest text-white/70">{t("footer.govt")}</p>
        </div>

        <div>
          <div className="tag mb-4">{t("footer.centres")}</div>
          <ul className="space-y-2 text-sm text-white/85">
            {byCategory.centre.map((c) => (
              <li key={c.slug}><Link to={`/initiatives/${c.slug}`} className="hover:text-amber">{c.title}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <div className="tag mb-4">{t("footer.programmes")}</div>
          <ul className="space-y-2 text-sm text-white/85">
            {[...byCategory.programme, ...byCategory.incubation].map((c) => (
              <li key={c.slug}><Link to={`/initiatives/${c.slug}`} className="hover:text-amber">{c.title}</Link></li>
            ))}
            <li><Link to="/chipmat" className="hover:text-amber font-medium">{t("nav.chipmat")}</Link></li>
          </ul>
        </div>

        <div>
          <div className="tag mb-4">{t("footer.explore")}</div>
          <ul className="space-y-2 text-sm text-white/85 mb-8">
            <li><Link to="/directors" className="hover:text-amber">{t("nav.board")}</Link></li>
            <li><Link to="/startups" className="hover:text-amber">{t("footer.startups_directory")}</Link></li>
            <li><Link to="/careers" className="hover:text-amber">{t("nav.careers")}</Link></li>
            <li><Link to="/gallery" className="hover:text-amber">{t("nav.gallery")}</Link></li>
            <li><Link to="/admin/login" className="hover:text-amber">{t("footer.admin")}</Link></li>
          </ul>
          <div className="tag mb-4">{t("footer.contact")}</div>
          <ul className="space-y-3 text-sm text-white/85">
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 text-amber mt-0.5 shrink-0" aria-hidden="true" />
              <span>Semicon Keralam (IIITM-K), Technopark Phase 1, Thiruvananthapuram, Kerala 695584</span>
            </li>
            <li className="flex items-center gap-2">
              <Mail className="w-4 h-4 text-amber" aria-hidden="true" />
              <a href="mailto:info@iiitmk.ac.in" className="hover:text-amber">info@iiitmk.ac.in</a>
            </li>
            <li className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-amber" aria-hidden="true" />
              <a href="tel:+914712700777" className="hover:text-amber">+91-471-2700777</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/15">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-14 flex items-center justify-between font-mono text-xs text-white/75">
          <div>© {new Date().getFullYear()} {t("meta.brand")}. {t("footer.rights")}</div>
          <div className="hidden md:block">{t("footer.brand_line")}</div>
        </div>
      </div>
    </footer>
  );
}
